import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { Withdrawal, getWithdrawal } from '../../details'
import { RejectWithdrawal, RejectWithdrawalForm } from './types'
import { transactionRequestStatus } from '../../../const'
import { withdrawalMounted } from '../../edit/model'

export const mounted = createEvent()
export const unmounted = createEvent()

export const setReject = createEvent<RejectWithdrawalForm>()
export const $reject = restore<RejectWithdrawalForm>(setReject, {
  rejectReason: '',
  inputs: '',
  rejectReasonType: 0,
})

// submit reject

export const submitReject = createEvent<RejectWithdrawal>()

export const rejectTransactionRequest = fx<RejectWithdrawal, Withdrawal>({
  method: 'PUT',
  url: `/transaction_request/`,
})

sample({
  clock: submitReject,
  fn: ({
    requestId,
    managerComment,
    rejectReason,
    rejectReasonType,
    managerEmail,
  }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
        ]),
      },
      body: {
        requestId: requestId,
        status: transactionRequestStatus.rejected(),
        managerComment: managerComment,
        rejectReason: rejectReason,
        rejectReasonType: rejectReasonType,
        managerEmail: managerEmail,
      },
      url: `/transaction_request/${requestId}`,
    }
  },
  target: rejectTransactionRequest,
})

// clear field on success

sample({
  clock: rejectTransactionRequest.done,
  fn: () => ({}),
  target: [withdrawalMounted],
})
